import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import {
  CmsStructureModel,
  CMS_PAGE_NORMALIZER,
  ConverterService,
  OccCmsPageAdapter,
  OccCmsPageRequest,
  OccEndpointsService,
  PageContext,
  PageType,
  RoutingService,
  WindowRef
} from '@spartacus/core'
import { Observable, of } from 'rxjs'
import { catchError } from 'rxjs/operators'

@Injectable({ providedIn: 'root' })
export class EbCmsPageAdapter extends OccCmsPageAdapter {
  private static readonly HOMEPAGE_LABEL = '/homepage'
  private static readonly SPARTACUS_HOMEPAGE_CONTEXT = '__HOMEPAGE__'

  constructor(
    http: HttpClient,
    occEndpoints: OccEndpointsService,
    converter: ConverterService,
    protected routingService: RoutingService,
    protected router: Router,
    protected winRef: WindowRef
  ) {
    super(http, occEndpoints, converter)
  }

  private static checkResponseForSilentRedirect(response) {
    const rule = error => {
      return (
        (error.reason === 'invalid' && error.subject === 'code') ||
        (error.reason === 'missing' && error.subject === 'salesArea')
      )
    }
    return !!response?.error?.errors?.find(rule)
  }

  private static removeCountryLanguagePatternFromContextId(url: string): string {
    return url.replace(/^\/?[A-Z]{2}\/[a-z]{2}(\/|$)/, '$1')
  }

  private static normalizeContentPageId(id: string): string {
    const pageId = EbCmsPageAdapter.removeCountryLanguagePatternFromContextId(id)

    return pageId === EbCmsPageAdapter.SPARTACUS_HOMEPAGE_CONTEXT
      ? EbCmsPageAdapter.HOMEPAGE_LABEL
      : pageId
  }

  load(pageContext: PageContext): Observable<CmsStructureModel> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json')
    const id = EbCmsPageAdapter.normalizeContentPageId(pageContext.id)

    if (id === '' || id === '/') {
      pageContext = { id: EbCmsPageAdapter.HOMEPAGE_LABEL, type: PageType.CONTENT_PAGE }
    } else {
      pageContext = { ...pageContext, id }
    }

    const params = this.getPagesRequestParams(pageContext)

    const endpoint = pageContext.type
      ? this.occEndpoints.buildUrl('pages', { queryParams: params })
      : this.occEndpoints.buildUrl('page', {
          urlParams: { id: pageContext.id }
        })

    return this.http.get(endpoint, { headers }).pipe(
      catchError(response => {
        if (EbCmsPageAdapter.checkResponseForSilentRedirect(response)) {
          this.routingService.go('/')
        }
        return of(response)
      }),
      this.converter.pipeable(CMS_PAGE_NORMALIZER)
    )
  }

  protected getPagesRequestParams(context: PageContext): OccCmsPageRequest {
    const httpParams: OccCmsPageRequest = {}
    if (context.type) {
      httpParams.pageType = context.type
    }
    if (context.type === PageType.CONTENT_PAGE) {
      const id = EbCmsPageAdapter.normalizeContentPageId(context.id)
      httpParams.pageLabelOrId = id || EbCmsPageAdapter.HOMEPAGE_LABEL
    } else {
      httpParams.code = context.id
    }

    return httpParams
  }
}
